const manageReservationTypes = {
  GET_MANAGERESERVATIONDETAILS_REQUEST: 'FETCH_MANAGE_RESERVATION_DETAILS_REQUEST',
  GET_MANAGERESERVATIONDETAILS_SUCCESS: 'FETCH_MANAGE_RESERVATION_DETAILS_SUCCESS',
  GET_MANAGERESERVATIONDETAILS_FAILURE: 'FETCH_MANAGE_RESERVATION_DETAILS_FAILURE',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS:
    'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR: 'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR: 'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR:
    'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR',
  GET_COMPARISON_CHANGES_REQUEST: 'GET_COMPARISON_CHANGES_REQUEST',
  GET_COMPARISON_CHANGES_SUCCESS: 'GET_COMPARISON_CHANGES_SUCCESS',
  GET_COMPARISON_CHANGES_FAILURE: 'GET_COMPARISON_CHANGES_FAILURE',
  GET_COMPARISON_CHANGES_CLEAN: 'GET_COMPARISON_CHANGES_CLEAN',
  GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS: 'GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS',
  CLEAR_MANAGERESERVATIONDETAILS: 'CLEAR_MANAGERESERVATIONDETAILS',
  FETCH_RESERVATION_ADD_ONS_REQUEST: 'FETCH_MANAGE_RESERVATION_ADD_ONS_REQUEST',
  FETCH_RESERVATION_ADD_ONS_SUCCESS: 'FETCH_MANAGE_RESERVATION_ADD_ONS_SUCCESS',
  FETCH_RESERVATION_ADD_ONS_FAILURE: 'FETCH_MANAGE_RESERVATION_ADD_ONS_FAILURE',
  CLEAR_RESERVATION_PACKAGES_UPDATE: 'CLEAR_RESERVATION_PACKAGES_UPDATE',
  FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS: 'FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS',
  CLEAR_RESERVATION_DETAILS_DETAILS_ERROR: 'CLEAR_RESERVATION_DETAILS_DETAILS_ERROR',
  CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR: 'CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR',
  RESERVATION_DETAILS_CABANA_IS_LOADING: 'RESERVATION_DETAILS_CABANA_IS_LOADING',
  RESERVATION_DETAILS_CABANA_SUCCESS: 'RESERVATION_DETAILS_CABANA_SUCCESS',
  RESERVATION_DETAILS_CABANA_FAILURE: 'RESERVATION_DETAILS_CABANA_FAILURE',
  CLEAR_RESERVATION_DETAILS_CABANA_DETAILS: 'CLEAR_RESERVATION_DETAILS_CABANA_DETAILS',
  PACKAGE_RESERVATION_LOADING_ERROR: 'PACKAGE_RESERVATION_LOADING_ERROR',
  GTM_POST_RESERVATION_DETAILS_SALE_PACKAGE_ADDED: 'GTM_POST_RESERVATION_DETAILS_SALE_PACKAGE_ADDED'
};

export default manageReservationTypes;
